// ========================================
// HOOK useAboutPage
// Gestion du contenu de la page À Propos
// ========================================

import { useState, useEffect, useCallback } from 'react';
import {
  getAboutContent,
  updateProfile,
  updateBio,
  updateValues,
  updateTimeline,
  updateSkills,
  updateContact,
  updateCV
} from '../services/firebase/aboutService';
import { toast } from 'react-toastify';

const useAboutPage = (autoFetch = true) => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const fetchContent = useCallback(async () => {
    setLoading(true);
    setError(null);

    const result = await getAboutContent();

    if (result.success) {
      setContent(result.data);
    } else {
      setError(result.error);
    }

    setLoading(false);
  }, []);

  useEffect(() => {
    if (autoFetch) {
      fetchContent();
    }
  }, [autoFetch, fetchContent]);

  const saveProfile = async (profileData) => {
    setSaving(true);
    const result = await updateProfile(profileData);
    if (result.success) {
      setContent(prev => ({ ...prev, profile: profileData }));
      toast.success('Profil sauvegardé !');
    } else {
      toast.error('Erreur lors de la sauvegarde');
    }
    setSaving(false);
    return result;
  };

  const saveBio = async (bio) => {
    setSaving(true);
    const result = await updateBio(bio);
    if (result.success) {
      setContent(prev => ({ ...prev, bio }));
      toast.success('Biographie sauvegardée !');
    } else {
      toast.error('Erreur lors de la sauvegarde');
    }
    setSaving(false);
    return result;
  };

  const saveValues = async (values) => {
    setSaving(true);
    const result = await updateValues(values);
    if (result.success) {
      setContent(prev => ({ ...prev, values }));
      toast.success('Valeurs sauvegardées !');
    } else {
      toast.error('Erreur lors de la sauvegarde');
    }
    setSaving(false);
    return result;
  };

  const saveTimeline = async (timeline) => {
    setSaving(true);
    const result = await updateTimeline(timeline);
    if (result.success) {
      setContent(prev => ({ ...prev, timeline }));
      toast.success('Parcours sauvegardé !');
    } else {
      toast.error('Erreur lors de la sauvegarde');
    }
    setSaving(false);
    return result;
  };

  const saveSkills = async (skills) => {
    setSaving(true);
    const result = await updateSkills(skills);
    if (result.success) {
      setContent(prev => ({ ...prev, skills }));
      toast.success('Compétences sauvegardées !');
    } else {
      toast.error('Erreur lors de la sauvegarde');
    }
    setSaving(false);
    return result;
  };

  const saveContact = async (contact) => {
    setSaving(true);
    const result = await updateContact(contact);
    if (result.success) {
      setContent(prev => ({ ...prev, contact }));
      toast.success('Contact sauvegardé !');
    } else {
      toast.error('Erreur lors de la sauvegarde');
    }
    setSaving(false);
    return result;
  };

  const saveCV = async (cvUrl) => {
    setSaving(true);
    const result = await updateCV(cvUrl);
    if (result.success) {
      setContent(prev => ({ ...prev, cvUrl }));
      toast.success('CV sauvegardé !');
    } else {
      toast.error('Erreur lors de la sauvegarde');
    }
    setSaving(false);
    return result;
  };

  return {
    content,
    loading,
    saving,
    error,
    fetchContent,
    saveProfile,
    saveBio,
    saveValues,
    saveTimeline,
    saveSkills,
    saveContact,
    saveCV
  };
};

export default useAboutPage;